var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/* eslint consistent-return: 0 */

import isString from 'lodash/isString';

export function sdrn(id) {
  var realm = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'schibsted.com';

  return 'sdrn:' + realm + ':user:' + id;
}

/**
 * Test
 */


function formatActorInput(input) {
  if (isString(input)) {
    return { id: input };
  }

  var _ref = input || {},
      id = _ref.id,
      realm = _ref.realm,
      rest = _objectWithoutProperties(_ref, ['id', 'realm']);

  return _extends({ id: id, realm: realm }, rest);
}

/**
 * Function to generate a builder for Actor objects.
 *
 */
export default function actor(builderInput) {
  var _ref2 = builderInput || {},
      actorData = _ref2.actor;

  var _formatActorInput = formatActorInput(actorData),
      id = _formatActorInput.id,
      realm = _formatActorInput.realm,
      props = _objectWithoutProperties(_formatActorInput, ['id', 'realm']);

  if (!id) {
    return undefined;
  }

  return Object.assign({
    '@id': sdrn(id, realm),
    'spt:userId': sdrn(id, realm)
  }, props);
}

export function defaultValue() {}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@spt-tracking/pulse-event-builders/dist/ejs/actor.js
// module id = 523
// module chunks = 0